<template>
  <div class="arc-sec">
    <div class="arc-toolbar">
      <div class="chips">
        <button v-for="p in pilares" :key="p.v" class="chip" :class="{ on: filtroPilar === p.v }" type="button" @click="filtroPilar = p.v">{{ p.l }}</button>
      </div>
      <div class="chips">
        <button v-for="r in resps" :key="r.v" class="chip" :class="{ on: filtroResp === r.v }" type="button" @click="filtroResp = r.v">{{ r.l }}</button>
      </div>
      <div class="spacer" />
      <button class="btn" type="button" @click="addFromTemplate">{{ $t('ARC_MGMT.DELIVERABLES.ADD_FROM_TEMPLATE') }}</button>
      <button class="btn primary" type="button" @click="openNew">+ {{ $t('ARC_MGMT.DELIVERABLES.NEW') }}</button>
    </div>

    <div v-if="loading" class="muted">{{ $t('ARC_MGMT.LOADING') }}</div>
    <template v-else>
      <div v-for="mes in mesesComItens" :key="mes" class="arc-month">
        <h4>{{ $t('ARC_MGMT.DELIVERABLES.MONTH') }} {{ mes }}</h4>
        <table>
          <tbody>
            <tr v-for="d in porMes(mes)" :key="d.id">
              <td class="pilar"><span class="pl" :class="d.pilar">{{ d.pilar }}</span></td>
              <td class="nome">
                {{ d.nome }}
                <span v-if="d.marco" class="marco">★ {{ d.nome_marco }}</span>
                <span v-if="d.atrasada" class="late">{{ $t('ARC_MGMT.DELIVERABLES.LATE') }}</span>
              </td>
              <td class="who">{{ d.responsavel === 'cliente' ? $t('ARC_MGMT.DELIVERABLES.CLIENT') : 'Interativa' }}</td>
              <td>
                <select class="status" :value="d.status" @change="changeStatus(d, $event.target.value)">
                  <option v-for="s in statuses" :key="s" :value="s">{{ $t('ARC_MGMT.STATUS.' + s) }}</option>
                </select>
              </td>
              <td class="acts">
                <button class="link" type="button" @click="openEdit(d)">{{ $t('ARC_MGMT.EDIT') }}</button>
                <button class="link danger" type="button" @click="remove(d)">{{ $t('ARC_MGMT.DELETE') }}</button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <p class="footer">{{ $t('ARC_MGMT.DELIVERABLES.SUMMARY', { x: concluidas, y: total }) }}</p>
    </template>

    <!-- modal criar/editar -->
    <div v-if="showModal" class="arc-modal-bg" @click.self="showModal = false">
      <div class="arc-modal">
        <h3>{{ editing.id ? $t('ARC_MGMT.EDIT') : $t('ARC_MGMT.DELIVERABLES.NEW') }}</h3>
        <label>{{ $t('ARC_MGMT.DELIVERABLES.NAME') }}<input v-model="editing.nome" type="text" /></label>
        <label>{{ $t('ARC_MGMT.DELIVERABLES.DESC') }}<textarea v-model="editing.descricao" rows="2" /></label>
        <div class="row">
          <label>{{ $t('ARC_MGMT.DELIVERABLES.MONTH') }}<input v-model.number="editing.mes" type="number" min="1" max="12" /></label>
          <label>{{ $t('ARC_MGMT.PILLAR') }}
            <select v-model="editing.pilar"><option>A</option><option>R</option><option>C</option></select>
          </label>
          <label>{{ $t('ARC_MGMT.RESPONSIBLE') }}
            <select v-model="editing.responsavel"><option value="interativa">Interativa</option><option value="cliente">Cliente</option></select>
          </label>
        </div>
        <label class="chk"><input v-model="editing.marco" type="checkbox" /> {{ $t('ARC_MGMT.DELIVERABLES.MILESTONE') }}</label>
        <label v-if="editing.marco">{{ $t('ARC_MGMT.DELIVERABLES.MILESTONE_NAME') }}<input v-model="editing.nome_marco" type="text" /></label>
        <div class="modal-actions">
          <button class="btn" type="button" @click="showModal = false">{{ $t('ARC_MGMT.CANCEL') }}</button>
          <button class="btn primary" type="button" @click="saveDeliverable">{{ $t('ARC_MGMT.SAVE') }}</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ArcAPI from 'dashboard/api/arc';

export default {
  props: { journey: { type: Object, default: () => ({}) }, cycle: { type: [Number, String], default: null } },
  data() {
    return {
      items: [], loading: true,
      filtroPilar: 'all', filtroResp: 'all',
      statuses: ['planejado', 'em_andamento', 'aguardando_cliente', 'entregue', 'validado', 'nao_aplicavel'],
      pilares: [{ v: 'all', l: 'Todos' }, { v: 'A', l: 'Atendimento' }, { v: 'R', l: 'Receita' }, { v: 'C', l: 'Custo' }],
      resps: [{ v: 'all', l: 'Todos' }, { v: 'interativa', l: 'Interativa' }, { v: 'cliente', l: 'Sua equipe' }],
      showModal: false, editing: {},
    };
  },
  computed: {
    filtered() {
      return this.items.filter(d =>
        (this.filtroPilar === 'all' || d.pilar === this.filtroPilar) &&
        (this.filtroResp === 'all' || d.responsavel === this.filtroResp));
    },
    mesesComItens() {
      return [...new Set(this.filtered.map(d => d.mes))].sort((a, b) => a - b);
    },
    total() { return this.items.filter(d => d.status !== 'nao_aplicavel').length; },
    concluidas() { return this.items.filter(d => ['entregue', 'validado'].includes(d.status)).length; },
  },
  mounted() { this.load(); },
  methods: {
    async load() {
      this.loading = true;
      try {
        const { data } = await ArcAPI.deliverables();
        this.items = data.payload || [];
      } finally {
        this.loading = false;
      }
    },
    porMes(mes) { return this.filtered.filter(d => d.mes === mes).sort((a, b) => a.ordem - b.ordem); },
    async changeStatus(d, status) {
      if (status === d.status) return;
      let pendencia = null;
      if (status === 'aguardando_cliente') {
        // eslint-disable-next-line no-alert
        pendencia = window.prompt(this.$t('ARC_MGMT.DELIVERABLES.PENDING_PROMPT'));
        if (!pendencia) { this.load(); return; }
      }
      try {
        await ArcAPI.updateDeliverable(d.id, { status }, pendencia ? { pendencia } : {});
        this.load();
        this.$emit('refresh');
      } catch (e) {
        this.load();
      }
    },
    openNew() { this.editing = { mes: this.journey.mes_atual || 1, pilar: 'A', responsavel: 'interativa', marco: false }; this.showModal = true; },
    openEdit(d) { this.editing = { ...d }; this.showModal = true; },
    async saveDeliverable() {
      const payload = (({ nome, descricao, mes, pilar, responsavel, marco, nome_marco }) =>
        ({ nome, descricao, mes, pilar, responsavel, marco, nome_marco }))(this.editing);
      if (this.editing.id) {
        await ArcAPI.updateDeliverable(this.editing.id, payload);
      } else {
        await ArcAPI.createDeliverable(payload);
      }
      this.showModal = false;
      this.load();
      this.$emit('refresh');
    },
    async remove(d) {
      // eslint-disable-next-line no-alert
      if (!window.confirm(this.$t('ARC_MGMT.DELIVERABLES.DELETE_CONFIRM'))) return;
      await ArcAPI.deleteDeliverable(d.id);
      this.load();
    },
    async addFromTemplate() {
      const { data } = await ArcAPI.addDeliverablesFromTemplate(null);
      this.load();
      // eslint-disable-next-line no-alert
      window.alert(this.$t('ARC_MGMT.DELIVERABLES.ADDED', { n: data.adicionadas }));
    },
  },
};
</script>

<style lang="scss" scoped>
.arc-toolbar { display: flex; align-items: center; gap: var(--space-small); flex-wrap: wrap; margin-bottom: var(--space-normal); }
.spacer { flex: 1; }
.chips { display: flex; gap: var(--space-micro); }
.chip { border: 1px solid var(--s-200); background: var(--white); border-radius: 9999px; padding: var(--space-micro) var(--space-small); font-size: var(--font-size-mini); color: var(--s-600); cursor: pointer;
  &.on { background: var(--s-800); border-color: var(--s-800); color: var(--white); } }
.arc-month { margin-bottom: var(--space-normal);
  h4 { font-size: var(--font-size-small); color: var(--s-500); margin: 0 0 var(--space-smaller); text-transform: uppercase; letter-spacing: .4px; } }
table { width: 100%; border-collapse: collapse; }
td { padding: var(--space-small); border-bottom: 1px solid var(--s-75); font-size: var(--font-size-small); color: var(--s-800); vertical-align: middle; }
.pilar { width: 2.4rem; }
.pl { display: inline-grid; place-items: center; width: 1.8rem; height: 1.8rem; border-radius: var(--border-radius-normal); font-weight: var(--font-weight-bold); font-size: var(--font-size-mini);
  &.A { background: #E6F1FC; color: #1E88E5; } &.R { background: #E7F6EE; color: #1F9D63; } &.C { background: #EFECFF; color: #7B61FF; } }
.nome { font-weight: var(--font-weight-medium); }
.marco { color: var(--y-700); font-size: var(--font-size-mini); margin-left: var(--space-small); }
.late { color: var(--r-500); font-size: var(--font-size-mini); margin-left: var(--space-small); }
.who { color: var(--s-500); }
.status { height: var(--space-large); border: 1px solid var(--s-200); border-radius: var(--border-radius-normal); background: var(--white); color: var(--s-800); padding: 0 var(--space-small); }
.acts { text-align: right; white-space: nowrap; }
.link { border: 0; background: none; color: var(--w-600); font-size: var(--font-size-mini); cursor: pointer; padding: 0 var(--space-smaller);
  &.danger { color: var(--r-500); } }
.footer { color: var(--s-500); font-size: var(--font-size-small); margin-top: var(--space-normal); }
.muted { color: var(--s-500); }
.btn { height: var(--space-large); padding: 0 var(--space-normal); border-radius: var(--border-radius-normal); border: 1px solid var(--s-200); background: var(--white); color: var(--s-700); font-weight: var(--font-weight-medium); cursor: pointer;
  &.primary { background: var(--w-500); border-color: var(--w-500); color: var(--white); } }
.arc-modal-bg { position: fixed; inset: 0; background: rgba(0,0,0,.4); display: grid; place-items: center; z-index: 9999; }
.arc-modal { background: var(--white); border-radius: var(--border-radius-large); padding: var(--space-large); width: 32rem; max-width: 92vw; max-height: 90vh; overflow: auto;
  h3 { margin: 0 0 var(--space-normal); color: var(--s-900); }
  label { display: flex; flex-direction: column; gap: var(--space-smaller); font-size: var(--font-size-small); color: var(--s-700); margin-bottom: var(--space-small); }
  input[type='text'], input[type='number'], textarea, select { border: 1px solid var(--s-200); border-radius: var(--border-radius-normal); padding: var(--space-smaller) var(--space-small); background: var(--white); color: var(--s-800); }
  .row { display: grid; grid-template-columns: 1fr 1fr 1fr; gap: var(--space-small); }
  .chk { flex-direction: row; align-items: center; gap: var(--space-small); } }
.modal-actions { display: flex; justify-content: flex-end; gap: var(--space-small); margin-top: var(--space-normal); }
</style>
